import { Link, useNavigate } from 'react-router-dom';
import React, { Fragment, useState } from 'react'
import { Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { handleInterview } from '../../../../../ReduxToolkit/Reducers/LetterBoxReducer';
import { mailHeader } from '../../../../../Data/Applications/LetterBox';
import { ToolTip } from '../../../../../AbstractElements';
import DashboardSvgIcon from '../../../../../Utils/CommonComponents/DashboardSvgIcon';

export default function MailBody1({ onAddTask, taskDisabled, onAddNote, noteDisabled, hasTask, taskHref, onAddClient }: { onAddTask: () => void; taskDisabled: boolean; onAddNote: () => void; noteDisabled: boolean; hasTask: boolean; taskHref?: string; onAddClient: () => void }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [tooltipOpen, setTooltipOpen] = useState<number | null>(null);
    const toggle = (index: number) => {
        setTooltipOpen(tooltipOpen !== index ? index : null);
    };

    return (
        <div className="mail-header-wrapper header-wrapper1">
            <div className="mail-header1">
                <div className="light-square" onClick={() => { dispatch(handleInterview(false)); navigate(`${process.env.PUBLIC_URL || ""}/gestione-email`); }}>
                    <DashboardSvgIcon className="btn-email" iconId="back-arrow" />
                </div>
                <span>{'Interview Mail'}</span>
            </div>
            <div className="mail-body1 align-items-center">
                {hasTask ? (
                    taskHref && !taskDisabled ? <Link className="btn btn-primary" to={taskHref}>Vai al task</Link> : <Button type="button" color="primary" disabled>Vai al task</Button>
                ) : <Button type="button" color="primary" disabled={taskDisabled} onClick={onAddTask}>+ Task</Button>}
                <Button type="button" color="primary" disabled={noteDisabled} onClick={onAddNote}>+ Note</Button>
                <UncontrolledDropdown>
                    <DropdownToggle type="button" color="transparent" className="light-square border-0" aria-label="Altre azioni email" disabled={taskDisabled}>
                        <i className="fa-solid fa-ellipsis-vertical" aria-hidden="true" />
                    </DropdownToggle>
                    <DropdownMenu end>
                        <DropdownItem onClick={onAddClient}>Aggiungi Cliente</DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
                {mailHeader.filter(data => data.icon === "mail-trash").map((data, i) => (
                    <Fragment key={i}>
                        <div className="light-square" id={`light-${data.icon}`}>
                            <DashboardSvgIcon iconId={data.icon} className={data.className ? data.className : ""} />
                        </div>
                        <ToolTip placement="top" isOpen={tooltipOpen === i} target={`light-${data.icon}`} toggle={() => toggle(i)}>{data.tooltip}</ToolTip>
                    </Fragment>
                ))}
            </div>
        </div>
    );
};
